import { render, staticRenderFns } from "./AnxReadonly.vue?vue&type=template&id=f4c65b2e&scoped=true&"
import script from "./AnxReadonly.vue?vue&type=script&lang=ts&"
export * from "./AnxReadonly.vue?vue&type=script&lang=ts&"
import style0 from "./AnxReadonly.vue?vue&type=style&index=0&id=f4c65b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c65b2e",
  null
  
)

export default component.exports